import { render, staticRenderFns } from "./System.vue?vue&type=template&id=5fd632a2&"
import script from "./System.vue?vue&type=script&lang=ts&"
export * from "./System.vue?vue&type=script&lang=ts&"
import style0 from "./System.vue?vue&type=style&index=0&id=5fd632a2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports